import { Container, WithGradientedName } from '@/components';
import { Box, Typography } from '@mui/material';
import styles from './styles.module.scss';
import { Trans, useTranslation } from 'next-i18next';
import { FC } from 'react';
import Link from 'next/link';
import GDPRIcon from './assets/gdpr.svg';
import CCPAIcon from './assets/ccpa.svg';
import { ROUTES } from '@/libs/routing';

export const CompliantSection: FC = () => {
  const { t } = useTranslation('ourData');
  return (
    <Box component="section" className={styles.section}>
      <Container>
        <Box className={styles.container}>
          <Box className={styles.containerColLeft}>
            <Typography variant="h2" className={styles.title}>
              <WithGradientedName text={t('compliant.title')} lastLetterGradient />
            </Typography>
            <Typography variant="body1" className={styles.text}>
              <Trans
                i18nKey="compliant.text"
                ns="ourData"
                components={{
                  a: <Link href={ROUTES.PRIVACY_POLICY} />,
                  br: <br />,
                }}
              />
            </Typography>
          </Box>
          <Box className={styles.containerColRight}>
            <Box className={styles.iconBox}>
              <GDPRIcon />
            </Box>
            <Box className={styles.iconBox}>
              <CCPAIcon />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
